"use client"

import dynamic from "next/dynamic"
import { useEffect, useRef, useState } from "react"

const AiImageGeneratorTeaser = dynamic(() =>
  import("./ai-image-generator-teaser").then(
    (module) => module.AiImageGeneratorTeaser
  )
)

/** Loads the gallery/query stack only shortly before this far-below-fold section. */
export function DeferredAiImageGeneratorTeaser() {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    const target = containerRef.current
    if (!target || shouldLoad) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return
        setShouldLoad(true)
        observer.disconnect()
      },
      { rootMargin: "800px 0px" }
    )
    observer.observe(target)
    return () => observer.disconnect()
  }, [shouldLoad])

  return (
    <div ref={containerRef} className="min-h-[720px]" aria-busy={!shouldLoad}>
      {shouldLoad ? <AiImageGeneratorTeaser /> : null}
    </div>
  )
}
